import { render, staticRenderFns } from "./desc-images-new.vue?vue&type=template&id=2c80e4ff&scoped=true&"
import script from "./desc-images-new.vue?vue&type=script&lang=js&"
export * from "./desc-images-new.vue?vue&type=script&lang=js&"
import style0 from "./desc-images-new.vue?vue&type=style&index=0&id=2c80e4ff&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c80e4ff",
  null
  
)

component.options.__file = "desc-images-new.vue"
export default component.exports